import join from "lodash/join";
import React from "react";
import { FilterComponent } from "./";
import { buildTableValues } from "../../utils/customization/filter";

// prettier-ignore
const ALL_COEFS = [
  -22.968, 156.715, -428.569, 616.825, -508.725, 244.538, -67.949, 11.003, -0.816, 0.947, 0
];

// prettier-ignore
const GREYSCALE_MATRIX = [
  0.34,  0.5,  0.16,  0,  0,
  0.34,  0.5,  0.16,  0,  0,
  0.34,  0.5,  0.16,  0,  0,
  0,     0,    0,     0,  1,
];

let tableValues:
  | {
      rgb: string;
    }
  | undefined;

let matrixValues: string | undefined;

const Greycheerzou: FilterComponent = ({ id }) => {
  if (!tableValues) {
    tableValues = {
      rgb: buildTableValues(ALL_COEFS),
    };
  }
  if (!matrixValues) {
    matrixValues = join(GREYSCALE_MATRIX, " ");
  }

  return (
    <filter
      colorInterpolationFilters="sRGB"
      filterUnits="objectBoundingBox"
      height="100%"
      id={id}
      width="100%"
      x={0}
      y={0}
    >
      <feComponentTransfer in="SourceGraphic" result="adjusted">
        <feFuncR tableValues={tableValues.rgb} type="table" />
        <feFuncG tableValues={tableValues.rgb} type="table" />
        <feFuncB tableValues={tableValues.rgb} type="table" />
        <feFuncA type="identity" />
      </feComponentTransfer>
      <feColorMatrix in="adjusted" type="matrix" values={matrixValues} />
    </filter>
  );
};

export default Greycheerzou;
